export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发票"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["未找到发票"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["代码"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["日期"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["状态"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["评论"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["金额"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商店"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["地位"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["存储号码"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消发票"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["存储付款代码"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商店账户"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["详情"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商店ID"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["创建日期"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结束日期"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["金额"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["超时"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发票ID"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["分钟"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已付款"])},
  "24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已过期"])},
  "25": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已创建"])},
  "26": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["失败"])},
  "27": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已暂停"])},
  "28": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已退回"])},
  "29": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["未找到发票"])},
  "30": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我们找不到符合您筛选条件的发票。"])},
  "31": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请尝试调整日期或筛选条件。"])}
}